"use client";

/* ResourceGridDropdown is a dropdown component for the resource grid. It was developed for the RC. */
import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useState, useEffect } from "react";
import { FilterOption } from "../TabbedResourceGrid/BlogFilters";
import { Icon } from "@/components/formatters/MXPIcon";
import { emitGTMEvent } from "@/components/client/Datalayer/utilities";
const CHECKMARK_SVG = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M4 8l3 3 5-6'/%3E%3C/svg%3E\")";
const CHECKBOX_BASE = "min-w-[18px] min-h-[18px] cursor-pointer ml-auto appearance-none rounded border border-gray-m10 bg-transparent pointer-events-none";
const checkedStyle: React.CSSProperties = {
  backgroundColor: "#0063A3",
  borderColor: "#0063A3",
  backgroundImage: CHECKMARK_SVG,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundSize: "70%"
};
interface ResourceGridDropdownProps {
  options: any;
  selectedFilters: FilterOption[];
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  onChange: Function;
  title?: string;
  multiSelect?: boolean;
  labelClearAll?: string;
}
export const ResourceGridDropdown = t0 => {
  const $ = _c(31);
  const {
    options,
    onChange,
    title,
    selectedFilters: t1,
    multiSelect: t2,
    labelClearAll: t3
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const selectedFilters = t4;
  const multiSelect = t2 === undefined ? true : t2;
  const labelClearAll = t3 === undefined ? "Clear All" : t3;
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(selectedFilters);
  let t5;
  let t6;
  if ($[2] !== selectedFilters) {
    t5 = () => {
      setSelectedOptions(selectedFilters || []);
    };
    t6 = [selectedFilters];
    $[2] = selectedFilters;
    $[3] = t5;
    $[4] = t6;
  } else {
    t5 = $[3];
    t6 = $[4];
  }
  useEffect(t5, t6);
  let t7;
  if ($[5] !== multiSelect || $[6] !== onChange || $[7] !== selectedOptions || $[8] !== title) {
    t7 = option => {
      const wasSelected = !!selectedOptions?.find(selectedOption => selectedOption?.id === option?.id);
      let updatedSelectedOptions;
      if (multiSelect) {
        if (wasSelected) {
          updatedSelectedOptions = selectedOptions?.filter(selectedOption_0 => selectedOption_0?.id !== option?.id);
        } else {
          selectedOptions?.push(option);
          updatedSelectedOptions = [...selectedOptions];
        }
      } else {
        updatedSelectedOptions = [option];
      }
      emitGTMEvent({
        event: "blog_filter_applied",
        filter_category: title || option?.category?.title || "",
        filter_value: option?.title || "",
        filter_action: multiSelect && wasSelected ? "removed" : "applied",
        num_filters_applied: updatedSelectedOptions?.length ?? 0,
        current_page: typeof window !== "undefined" ? window.location.href : ""
      });
      setSelectedOptions(updatedSelectedOptions);
      onChange(updatedSelectedOptions);
    };
    $[5] = multiSelect;
    $[6] = onChange;
    $[7] = selectedOptions;
    $[8] = title;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleOptionClick = t7;
  let t8;
  if ($[10] !== onChange) {
    t8 = () => {
      setSelectedOptions([]);
      onChange([]);
    };
    $[10] = onChange;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const handleClearAll = t8;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = e => {
      if (!e.currentTarget.contains(e.relatedTarget)) {
        setIsOpen(false);
      }
    };
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const handleBlur = t9;
  const t10 = `relative rounded-lg min-w-[185px] w-fit border-none outline-none max-lg:w-full max-lg:bg-white max-lg:shadow-[0px_4px_4px_0px_rgba(0,0,0,0.12)] ${isOpen ? "shadow-[0px_4px_4px_0px_rgba(0,0,0,0.12)]" : ""}`;
  let t11;
  if ($[13] !== isOpen) {
    t11 = () => setIsOpen(!isOpen);
    $[13] = isOpen;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Icon label="Dropdown Icon" type="t2u-chevron-right" rotateDeg="90" size={12} />;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t11 || $[17] !== title) {
    t13 = <div className="flex gap-5 items-center justify-between px-4 py-2.5 rounded-lg cursor-pointer" onClick={t11} tabIndex={0}>{title}{t12}</div>;
    $[16] = t11;
    $[17] = title;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== handleClearAll || $[20] !== handleOptionClick || $[21] !== isOpen || $[22] !== labelClearAll || $[23] !== multiSelect || $[24] !== options || $[25] !== selectedOptions) {
    t14 = isOpen && <div className="mt-1.5 absolute bg-white z-10 w-full max-h-[300px] overflow-hidden flex flex-col rounded-lg shadow-[0px_4px_4px_0px_rgba(0,0,0,0.12)]"><ul className="list-none m-0 p-0 flex-1 overflow-y-auto flex flex-col">{options?.map((option_0, index) => {
          const id = option_0?.id;
          const title_0 = option_0?.title;
          const isChecked = selectedOptions?.find && selectedOptions?.find(selectedOption_1 => selectedOption_1?.id === id) ? true : false;
          return <li key={`option-${title_0}-${index}`} className="cursor-pointer px-4 py-2.5 flex items-center justify-between list-none hover:bg-gray-m1" onClick={() => handleOptionClick(option_0)}><span className={isChecked ? "font-semibold" : ""}>{title_0}</span><input type="checkbox" className={CHECKBOX_BASE} style={isChecked ? checkedStyle : undefined} checked={isChecked} onChange={() => handleOptionClick(option_0)} /></li>;
        })}</ul>{multiSelect && <div className="flex justify-between p-2 bg-white border-t border-gray-m2"><button className="border-none cursor-pointer text-sm font-bold leading-normal tracking-wide rounded uppercase bg-transparent text-gray-m3" onClick={handleClearAll}>{labelClearAll}</button></div>}</div>;
    $[19] = handleClearAll;
    $[20] = handleOptionClick;
    $[21] = isOpen;
    $[22] = labelClearAll;
    $[23] = multiSelect;
    $[24] = options;
    $[25] = selectedOptions;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t10 || $[28] !== t13 || $[29] !== t14) {
    t15 = <div className={t10} tabIndex={0} onBlur={handleBlur}>{t13}{t14}</div>;
    $[27] = t10;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  return t15;
};